// ThemedAddToCartButton.jsx - Reusable add to cart button with theme, loading, and conditional text
import React from "react";
import LoadingSpinner from "./LoadingSpinner";

const ThemedAddToCartButton = ({
  theme,
  onClick,
  disabled,
  isLoading,
  continueText = "Continue to Tickets",
  addText = "Add To Cart",
  showContinue = false,
}) => {
  const baseClass = `text-white px-2 py-2 font-extralight disabled:opacity-50 disabled:cursor-not-allowed ${
    theme === "pink"
      ? "bg-pink-secondary-500 hover:bg-pink-secondary-600 rounded-full"
      : "bg-blue-primary-500 hover:bg-blue-primary-600"
  }`;

  return (
    <button onClick={onClick} className={baseClass} disabled={disabled}>
      {showContinue ? (
        continueText
      ) : isLoading ? (
        <span className="flex items-center">
          <LoadingSpinner />
          Adding...
        </span>
      ) : (
        addText
      )}
    </button>
  );
};

export default ThemedAddToCartButton;